import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "./_shared";

export function ContactPanel() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/contact").then(({ data }) => setItems(data)); }, []);
  return (
    <div data-testid="contact-panel">
      <p className="eyebrow mb-2">Contact</p>
      <h1 className="font-serif-display text-4xl mb-8" style={{ color: "var(--ser-primary-dark)" }}>
        Contact submissions ({items.length})
      </h1>
      <div className="space-y-4">
        {items.length === 0 && <p style={{ color: "var(--ser-text-muted)" }}>No messages yet.</p>}
        {items.map((c) => (
          <div key={c.contact_id} className="ser-card p-6" data-testid={`contact-${c.contact_id}`}>
            <h3 className="font-semibold mb-1" style={{ color: "var(--ser-primary-dark)" }}>{c.subject}</h3>
            <p className="text-sm mb-3" style={{ color: "var(--ser-text-muted)" }}>
              <strong>{c.name}</strong> · {c.email} {c.phone && `· ${c.phone}`}
            </p>
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{c.message}</p>
            <p className="text-xs mt-3" style={{ color: "var(--ser-text-muted)" }}>{formatDateTime(c.created_at)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

